import React from "react";
import styles from "./FeatureCard.module.css";

import SecondaryButton from "../../../../Components/Buttons/SecondaryButton/SecondaryButton";
import { urls } from "../../../../Routes/Urls";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const FeatureCard = ({ image, title, btnText, description, altText }) => {
  const history = useHistory()
  return (
    <div className={styles.banner} onClick={() => {history.push({
                          pathname: urls.BESTSELLER,
                          search: "",
                      })}} aria-label={altText}>
      <img
        src={image}
        alt={altText}
        className={styles.bannerImage}
        width={1200}
        height={500}
        fetchpriority="high" 
        loading="eager"
        decoding="async"
      />
      <div className={styles.overlay}>
        <div className={styles.textContainer}>
          <h1 className={styles.heading}>{title}</h1>
          <p className={styles.description}>{description}</p>
        </div>
      </div>
    </div>
  );
};

export default FeatureCard;
